module.exports = __webpack_public_path__ + "media/6s-Ali-Imtiaz-Accounting.19abdae1.mp4";